// Local translations (only keys used directly in this component)
export const T = {
  en_GB: {
    fieldNotFound: "Field not found",
    riskModelNotConfigured: "Risk model not configured for this flow.",
  },
  nb_NO: {
    fieldNotFound: "Felt ikke funnet",
    riskModelNotConfigured: "Risikomodell er ikke konfigurert for denne flyten.",
  },
} as const;
